import { useState } from 'react';
import { Box, IconButton, Menu, MenuItem } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import useTemplateSx from '../../hooks/useTemplateSx';

export default function InsightsRowActions({ onView, onDownload }) {
  const styles = useTemplateSx();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClose = () => setAnchorEl(null);

  return (
    <Box
      sx={styles.actionColumnCell}
      onClick={(event) => event.stopPropagation()}
    >
      <IconButton
        size="small"
        onClick={(event) => {
          event.stopPropagation();
          setAnchorEl(event.currentTarget);
        }}
        aria-label="Actions"
        sx={styles.rowActionButton}
      >
        <MoreVertIcon fontSize="small" />
      </IconButton>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <MenuItem
          onClick={() => {
            handleClose();
            onView?.();
          }}
        >
          View
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleClose();
            onDownload?.();
          }}
        >
          Download
        </MenuItem>
      </Menu>
    </Box>
  );
}
